export default __webpack_public_path__ + "static/media/ms_logo3.434fa8d4.png";